import BudgetDemand from '../../../../../pages/vip/features/budget-demand/budget-demand';

export default BudgetDemand;
